import PropTypes from 'prop-types';
import Drawer from '@mui/material/Drawer';
import { RIGHT_DRAWER_WIDTH } from './constants';

const RightDrawer = (props) => {
	const {
		open,
		drawerWidth = RIGHT_DRAWER_WIDTH,
		onCloseDrawer,
		children,
	} = props;

	return (
		<Drawer
			sx={{
				'& .MuiDrawer-paper': { width: drawerWidth, maxWidth: '100%' },
			}}
			anchor="right"
			open={open}
			onClose={onCloseDrawer}
		>
			{children}
		</Drawer>
	);
};

RightDrawer.propTypes = {
	open: PropTypes.bool,
	drawerWidth: PropTypes.number,
	children: PropTypes.node,
	onCloseDrawer: PropTypes.func,
};

export default RightDrawer;
